import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videoData';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, idx) => ({
    '@type': 'ListItem' as const,
    position: idx + 1,
    item: item.href ? { '@id': `https://fulishipin.com${item.href}`, name: item.label } : { '@id': 'https://fulishipin.com', name: item.label },
  }));

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1">
              {idx > 0 && (
                <span className="mx-1 text-foreground-300" aria-hidden="true">/</span>
              )}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}

export function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}